import { useStaticQuery, graphql } from 'gatsby'

const GetNewsroomUrls = () => {
  const { newsroomList } = useStaticQuery(graphql`
    query {
      newsroomList: allContentfulNewsroomList(
        filter: {
          distributionChannel: { elemMatch: { title: { eq: "Site internet" } } }
        }
      ) {
        nodes {
          slug
          type
          node_locale
        }
      }
    }
  `)

  // Initialize newsroomUrls as an object instead of an array
  let newsroomUrls = {}

  newsroomList.nodes.forEach((item) => {
    // Ensure a structure for each type
    if (!newsroomUrls[item.type]) {
      newsroomUrls[item.type] = {}
    }

    // Assign the URL, considering the locale for the prefix
    newsroomUrls[item.type][item.node_locale] =
      `${item.node_locale === 'en' ? 'en/' : ''}${item.slug}`
  })

  return newsroomUrls
}

export default GetNewsroomUrls
